/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { type Registry as Services, service } from '@ember/service';

interface IArgs {
  title: string;
  description: string;
  buttonText: string;
}

interface UpgradeSubscriptionSignature {
  Element: HTMLDivElement;

  Args: IArgs;

  Blocks: {
    default: [];
  };
}

export default class UiUpgradeSubscriptionComponent extends Component<UpgradeSubscriptionSignature> {
  @service pricing!: Services['pricing'];

  @cached
  get isUpgradeNeeded(): boolean {
    return (
      this.pricing.customer?.isLegacyPlan || !!this.pricing.customer?.isSaving
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::UpgradeSubscription': typeof UiUpgradeSubscriptionComponent;
  }
}
